import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  TextField,
  Checkbox,
  FormControlLabel,
  Snackbar,
  Grid,
  Autocomplete,
} from "@mui/material";
import Alert from "@mui/material/Alert"; // Import Alert for Snackbar
import useFirestore from "../../../../config/fireBaseHook"; // Import useFirestore
import ModalDialogTitle from "../../../common/ModalDialogTitle";
import ModalActions from "../../../common/ModalActions";

const Add = ({ onRecordAdded }) => {
  const { addData } = useFirestore("TpPartners"); // Specify collection name
  const { data: sitesData, loading: sitesLoading } = useFirestore(
    "Sites",
    "SiteName",
    "asc",
  );
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const [formData, setFormData] = useState({
    PartnerIRN: "",
    Tech_Prep_Partner: "",
    Partner_Full_Name: "",
    Active_yn: "n",
    Sites: [], // Array of { SiteID, SiteName } tied to this partner
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: checked ? "y" : "n",
    }));
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      await addData(formData); // Use Firestore hook's addData
      setLoading(false);
      setSnackbarMessage("Record has been added successfully!");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
      setFormData({
        PartnerIRN: "",
        Tech_Prep_Partner: "",
        Partner_Full_Name: "",
        Active_yn: "n",
        Sites: [],
      });
      setOpen(false);
      if (onRecordAdded) onRecordAdded(); // Call the callback function
    } catch (error) {
      console.error("Error adding record:", error);
      setLoading(false);
      setSnackbarMessage(`Error adding record: ${error.message}`);
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <div>
      <Button
        variant="contained"
        color="success"
        onClick={() => setOpen(true)}
        sx={{ marginBottom: "10px", color: "white" }}
      >
        Add Partner
      </Button>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <ModalDialogTitle onClose={() => setOpen(false)}>
          Add Partner
        </ModalDialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.Active_yn === "y"}
                    onChange={handleCheckboxChange}
                    name="Active_yn"
                  />
                }
                label="Active"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Partner IRN"
                name="PartnerIRN"
                value={formData.PartnerIRN}
                onChange={handleChange}
                fullWidth
                margin="normal"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Tech Prep Partner"
                name="Tech_Prep_Partner"
                value={formData.Tech_Prep_Partner}
                onChange={handleChange}
                fullWidth
                margin="normal"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Full Name"
                name="Partner_Full_Name"
                value={formData.Partner_Full_Name}
                onChange={handleChange}
                fullWidth
                margin="normal"
              />
            </Grid>
            <Grid item xs={12}>
              <Autocomplete
                multiple
                options={sitesData || []}
                loading={sitesLoading}
                getOptionLabel={(option) => option.SiteName || ""}
                isOptionEqualToValue={(option, value) =>
                  option.SiteID === value.SiteID
                }
                value={formData.Sites}
                onChange={(event, newValue) =>
                  setFormData((prevData) => ({
                    ...prevData,
                    Sites: newValue.map((site) => ({
                      SiteID: site.SiteID,
                      SiteName: site.SiteName,
                    })),
                  }))
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Sites"
                    placeholder="Select sites..."
                    margin="normal"
                  />
                )}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <ModalActions onSave={handleSubmit} saving={loading} />
      </Dialog>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
          variant="filled"
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default Add;
